import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { images } from '../../utils/imagePaths';
import "../../styles/products.css";
import "../../styles/section.css"


const Products = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    document.body.style.overflow = selectedProduct ? 'hidden' : 'auto';

    const escClose = (e) => {
      if (e.key === 'Escape') setSelectedProduct(null);
    };

    window.addEventListener('keydown', escClose);
    return () => window.removeEventListener('keydown', escClose);
  }, [selectedProduct]);

  const products = [
    {
      id: 1,
      title: "General Trading Solutions",
      description: "GST eWay Bill & eInvoice enabled Inventory & Accounting Software with Purchase, Purchase Returns, Sales, Sales Returns, Stock Adjustments, Receipt Payment, Journal, Cheque Receipt & Payment, Barcode, Multi Rate, Multi Godown, ROL, ROQ, Stock Reports, Accounting Reports with Final Accounts",
      image: images.products.generalTrading,
      video: ""
    },
    {
      id: 2,
      title: "Super Market Solutions",
      description: "GST eWay Bill & eInvoice enabled Inventory & Accounting Software with Purchase, Purchase Returns, Sales, Sales Returns, Stock Adjustments, Receipt Payment, Journal, Cheque Receipt & Payment, Barcode, Multi Rate, Multi Godown, ROL, ROQ, Stock Reports, Accounting Reports with Final Accounts. Batchwise Stock with Expiry Date, Multi Printer Setup, Bill wise Ageing, Receivables & Payables Bill Wise",
      image: images.products.superMarket,
      video: "https://www.youtube.com/embed/zpOULjyy-n8?rel=0"
    },
    {
      id: 3,
      title: "Textiles Solutions",
      description: "GST eWay Bill & eInvoice enabled Inventory & Accounting Software with Purchase, Purchase Returns, Sales, Sales Returns, Stock Adjustments, Receipt Payment, Journal, Cheque Receipt & Payment, Barcode, Multi Rate, Multi Godown, ROL, ROQ, Stock Reports, Accounting Reports with Final Accounts",
      image: images.products.textiles,
      video: ""
    },
    {
      id: 4,
      title: "Pharmacy Solutions",
      description: "GST eWay Bill & eInvoice enabled Inventory & Accounting Software with Purchase, Purchase Returns, Sales, Sales Returns, Stock Adjustments, Receipt Payment, Journal, Cheque Receipt & Payment, Barcode, Multi Rate, Multi Godown, ROL, ROQ, Stock Reports, Accounting Reports with Final Accounts. Batchwise Stock with Expiry Date, Multi Printer Setup, Bill wise Ageing, Receivables & Payables Bill Wise, Supplier wise Reports, Category wise Reports, Content wise Search",
      image: images.products.pharmacy,
      video: ""
    },
    {
      id: 5,
      title: "Labour Management Solutions",
      description: "Labour management software solutions",
      image: images.products.labourManagement,
      video: ""
    },
    {
      id: 6,
      title: "Hospital Solutions",
      description: "Hospital management software solutions",
      image: images.products.hospitalSolution,
      video: ""
    },
    {
      id: 7,
      title: "Credit Risk Management Solutions",
      description: "Credit risk management software solutions",
      image: images.products.creditManagement,
      video: ""
    },
    {
      id: 8,
      title: "Lab Solutions",
      description: "Laboratory management software solutions",
      image: images.products.labSolutions,
      video: ""
    },
    {
      id: 9,
      title: "Bakery Solutions",
      description: "Bakery management software solutions",
      image: images.products.bakerySolutions,
      video: ""
    },
    {
      id: 10,
      title: "Optical Traders Solutions",
      description: "Optical traders management software solutions",
      image: images.products.opticalTraders,
      video: ""
    },
    {
      id: 11,
      title: "Production Management Solutions",
      description: "Production management software solutions",
      image: images.products.productionManagement,
      video: ""
    },
    {
      id: 12,
      title: "Online And Offline Softwares",
      description: "Online and offline software solutions",
      image: images.products.onlineOffline,
      video: ""
    },
    {
      id: 13,
      title: "Mobile Apps Solutions",
      description: "Mobile application development solutions",
      image: images.products.mobileApps,
      video: ""
    },
    {
      id: 14,
      title: "Insurance Agent Solutions",
      description: "Insurance agent management software solutions",
      image: images.products.insuranceAgent,
      video: ""
    }
  ];

  return (
    <>
      <section className="products" id="products">
        <div className="container">

          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Products</h2>
            <h3 className="section-head">
              We build software solutions for our client's business
            </h3>
          </motion.div>

          <motion.div className="products-list">
            {products.map(product => (
              <motion.figure
                key={product.id}
                className="products-figure"
                whileHover={{ scale: 1.05 }}
              >
                <div className="tile">
                  <img src={product.image} alt={product.title} />

                  <figcaption className="products-figure-caption">
                    <div className="products-figure-detail">
                      <h2>{product.title}</h2>
                      <p>{product.description.substring(0, 100)}...</p>
                    </div>

                    <span
                      className="link-btn"
                      onClick={(e) => {
                        e.stopPropagation();   // 🔴 important
                        setSelectedProduct(product);
                      }}
                    >
                      Read more
                    </span>
                  </figcaption>
                </div>
              </motion.figure>
            ))}
          </motion.div>

        </div>
      </section>

      {/* POPUP */}
      {selectedProduct && (
        <>
          <div
            className="product-popup-overlay"
            onClick={() => setSelectedProduct(null)}
          />

          <div className="product-popup">
            <button
              className="popup-close-btn"
              onClick={() => setSelectedProduct(null)}
              aria-label="Close popup"
            >
              ×
            </button>

            <div className="popup-content">
              <div className="popup-layout">

                <div className="popup-media">
                  {selectedProduct.video ? (
                    <div className="video-wrapper">
                      <iframe
                        src={selectedProduct.video}
                        title={selectedProduct.title}
                        allowFullScreen
                      />
                    </div>
                  ) : (
                    <img
                      src={selectedProduct.image}
                      alt={selectedProduct.title}
                      className="popup-image"
                    />
                  )}
                </div>

                <div className="popup-text">
                  <h2>{selectedProduct.title}</h2>
                  <p>{selectedProduct.description}</p>
                </div>

              </div>
            </div>

          </div>
        </>
      )}
    </>
  );
};

export default Products;
